export enum EGame {
  LoL = "lol",
  VALORANT = "valorant",
}
